import React, { useEffect } from "react";
import Title from "./Components/Title";
import DefaultLayout from "../Containers/Layout/DefaultLayout";

const AlbumListeningEvent = () => {
  var album = "https://streams.radiomast.io/station/159003bc-663f-409f-a066-380d3c628d76/player/widget?t=dark&s=1fbc5f71-e336-481b-97cb-e0b83831df04";
  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//rumbletalk.com/client/?B_aLnmdZ"
    );
    document.body.appendChild(addScript);
  }, []);
  return (
    <div className="page albumlisteningevent">
      <Title value="Album Listening Event" />
      <DefaultLayout
        disablePlayer
        disableBanner
        disableNavItems
      >
      <main className="event-lander">
        <section className="event-flex-container">
          <div className="event-column" id="rumble-container" style={{ height: "600px", marginTop: "150px"}}><div id="rt-2ce7eea6437e4f137a65ba95f2b41672"></div></div>
          <div className="event-column">
            <iframe title="radiomast-player" src={album} scrolling="no" frameBorder="0" allow="autoplay" style={{ margin: "50% 40%"}}></iframe>
          </div>
        </section>
      </main>
      </DefaultLayout>
    </div>
  );
};

export default AlbumListeningEvent;
